// extracted by mini-css-extract-plugin
export default {"section":"MapSection_section__XWkAw","map":"MapSection_map__TfqTT"};